<template>
  <header class="header-container">
    <div class="header">
      <img class="logo" src="@/assets/images/logo.png" alt="">
      <div class="center">
        <!-- <router-link to="/home">
          <div class="children">首页</div>
        </router-link> -->
        <router-link to="/maker">
          <div class="children">在线制作</div>
        </router-link>
        <router-link to="/vip">
          <div class="children">会员中心</div>
        </router-link>
        <router-link to="/help">
          <div class="children">使用教程</div>
        </router-link>
      </div>
      <div class="right" v-if="!token" @click="showLoginDialog">
        <button class="login">登录</button>
      </div>
      <div class="right" v-if="token" @mouseenter="showDialog"  @mouseleave="hideDialog">
        <span class="phone">{{userInfo.nick_name}}</span>
        <img v-show="userInfo.headpic_url" class="user" :src="userInfo.headpic_url" alt="">
        <img v-show="!userInfo.headpic_url" class="user" src="@/assets/images/user.png" alt="">
        <PersonalDialog v-show="visible" :userInfo="userInfo"></PersonalDialog>
      </div>
    </div>
    <LoginDialog v-if="!token"></LoginDialog>
    <div class="tips" v-show="tipsFlag">
      建议您使用：<a class="link" href="https://www.google.cn/chrome/" target="_blank">谷歌、</a>火狐、Safari、360安全、Edge等主流浏览器体验效果最佳。
    </div>
  </header>
</template>

<script>
import PersonalDialog from './personal-dialog.vue'
import LoginDialog from '@/components/login-dialog.vue'

export default {
  name: 'navbar',
  props: {
    msg: String
  },
  data() {
    return {
      visible: false,
      tipsFlag: false
    }
  },
  computed: {
    token () {
      return this.$store.state.global.token
    },
    userInfo () {
      return this.$store.state.global.userInfo
    }
  },
  components: {
    PersonalDialog,
    LoginDialog
  },
  mounted () {
    this.getBrowser()
  },
  methods: {
    getBrowser() {
      var ua = window.navigator.userAgent;
      var isFirefox = ua.indexOf("Firefox") != -1;
      var isChrome = ua.indexOf("Chrome") && window.chrome;
      var isSafari = ua.indexOf("Safari") != -1 && ua.indexOf("Version") != -1;
      if (isFirefox || isChrome || isSafari) {
        this.tipsFlag = false
      } else {
        this.tipsFlag = true
      }
    },
    jumpPersonal() {
      console.log('jumpPersonal');
      this.$router.push('/personal/vip')
    },
    showDialog() {
      this.visible = true
      clearTimeout(this.timeout)
    },
    hideDialog () {
      this.visible = false
    },
    showLoginDialog () {
      this.$store.dispatch('global/setToken', '')
      this.$store.dispatch('global/setUserInfo', '')
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.header-container {
  background-color: #fff;
  box-shadow: 0 4px 4px 0 rgba(37,37,37,0.06);
  position: absolute;
  width: 100%;
  height: 80px;
  top: 0;
  left: 0;
  z-index: 999;
  min-width: 1340px;
  .tips {
    position: absolute;
    top: 0;
    text-align: center;
    width: 100%;
    background: #fcd8dd47;
    color: #999;
    font-size: 14px;
    .link {
      color: #4E6EFF;
      text-decoration: none;
    }
  }
}
.header {
  font-size: 16px;
  display: flex;
  margin: 0 auto;
  height: 80px;
  align-items: center;
  position: relative;
  .logo {
    width: 120px;
    position: absolute;
    left: 5px;
  }
  .center {
    display: flex;
    flex: 1;
    font-size: 18px;
    color: #5E5E5E;
    justify-content: center;
    a {
      color: #5E5E5E;
      text-decoration: none;
      position: relative;
      &.active::after {
        position: absolute;
        left: 0;
        bottom: -1px;
        content: '';
        width: 100%;
        height: 4px;
        background-color: #F95E5E;
      }
    }
    .children {
      width: 150px;
      text-align: center;
      height: 80px;
      line-height: 80px;
    }
  }
  .right {
    position: absolute;
    right: 20px;
    cursor: pointer;
    height: 80px;
    display: flex;
    align-items: center;
    .login {
      background: #4E6EFF;
      border-radius: 4px;
      font-size: 16px;
      color: #FFFFFF;
      border: none;
      width: 100px;
      height: 40px;
    }
    .phone {
      font-size: 14px;
      color: #555555;
      vertical-align: middle;
      margin-right: 16px;
    }
    .user {
      width: 40px;
      height: 40px;
      vertical-align: middle;
      border-radius: 20px;
    }
  }
}
</style>
